import { Injectable } from '@angular/core';
import { SecurityInfo, SymbolType } from '../../../../../../domain/symbol.domain';
import { OrderSecurity } from '../../../../../../domain/security.domain';
import {
  EquityExtendedTerms,
  OrderItem,
  InsiderType
} from '../../../../domain';

import { OrderEntryUtilityService } from '../../order-entry-utility.service';
import  { CalculatorFractionalTypes, EquityFormModel } from '../../../domain/order-entry.domain';
import { BackendMapper } from '../../../domain/services.domain';
import { CreateOrderMapper } from './create-order-mapper.service';

@Injectable()
export class CreateStockOrderMapper extends CreateOrderMapper<EquityFormModel> implements BackendMapper<EquityFormModel> {

  getMapperType(): OrderSecurity {
    return 'equity';
  }

  getItems(formModel: EquityFormModel): Array<OrderItem> {
    return [{
      clientInfo: this.getOrderItemClientInfo(formModel.shareholderStatus),
      quantity: formModel.fractionalType === CalculatorFractionalTypes.NOTIONAL ? undefined : formModel.orderQuantity,
      dollarAmt: formModel.fractionalType === CalculatorFractionalTypes.NOTIONAL ? formModel.orderAmount : undefined,
      extendedTerms: this.getOrderItemExtendedTerms(formModel),
      security: this.getOrderItemSecurity(formModel)
    }];
  }

  protected getOrderItemExtendedTerms(formModel: EquityFormModel): EquityExtendedTerms {
    const extendedTerms = {
      allOrNone: formModel.orderAllOrNone,
      goodTill: formModel.orderGoodTil,
      goodTillDate: formModel.orderGoodTilDate,
      orderAction: formModel.orderAction,
      orderType: formModel.orderPrice
    } as EquityExtendedTerms;

    OrderEntryUtilityService.setEquityPrice(extendedTerms,
      formModel.orderPrice,
      formModel.orderPriceAmount);

    return extendedTerms;
  }

  protected getOrderItemSecurity(formModel: EquityFormModel): SecurityInfo {
    return {
      symbol: formModel.selectedSymbol.symbol,
      market: formModel.selectedSymbol.market,
      type: SymbolType.EQUITY // TODO review formModel.getSecurityType()
    };
  }

  protected getOrderItemClientInfo(status: InsiderType): { insiderInfo: InsiderType; solicited: boolean } {
    return {
      insiderInfo: status === undefined ? null : status,
      solicited: false
    };
  }
}

